import { useMutation } from '@tanstack/react-query';

import { customFetcher } from '../useFetch';

/**
 * Portal-Trigger im Ident-Service: fordert die angehakten Beteiligten auf, im
 * Mandantenportal Ausweis + Stammdaten selbst zu erfassen. Setzt das
 * Vorgangs-Flag `RequestClientData`, schreibt die pro-Mandant-Auswahl und
 * loest die Aufforderungs-Mail sofort aus (ohne kompletten Vorgangs-Save).
 * Der Vorgang wird direkt ins Mandantenportal synchronisiert, wo der
 * Erfassungs-Aufruf erscheint.
 */
export const useSetRequestClientData = () => {
  const {
    mutateAsync: setRequestClientData,
    isPending: isSettingRequestClientData,
  } = useMutation({
    mutationFn: ({
      idLegalTransaction,
      value,
      clientIds,
      additive,
      resend,
    }: {
      idLegalTransaction: number;
      value: boolean;
      /** Optional: idLegalClient der aufzufordernden Beteiligten. */
      clientIds?: number[];
      /** Mail auch dann schicken, wenn sie schon einmal rausging. Ohne das
       *  greift der Dedup über `RequestClientDataSentAt` und ein erneutes
       *  Anfordern bleibt wirkungslos. */
      resend?: boolean;
      /** clientIds ergänzen statt die Auswahl autoritativ zu setzen. Der
       *  Panel-Button muss das setzen: er schickt nur die gerade angehakten
       *  Beteiligten, autoritativ gelesen würde damit jede frühere
       *  Aufforderung still widerrufen (#1265). */
      additive?: boolean;
    }) =>
      customFetcher({
        endpoint: `/legaltransaction/${idLegalTransaction}/requestClientData`,
        method: 'PUT',
        body: {
          value,
          ...(clientIds ? { clientIds } : {}),
          ...(additive ? { additive: true } : {}),
          ...(resend ? { resend: true } : {}),
        },
      }),
  });

  return { setRequestClientData, isSettingRequestClientData };
};
